import { useState, useEffect } from "react";
import {
  Button,
  Table,
  Modal,
  Input,
  Form,
  Tooltip,
} from "antd";
import type { FormProps, TableProps } from "antd";
import styled from "styled-components";

import Attatchment from "../post/Attatchment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { currentCategoryAtom, currentPostAtom } from "../../atom";
import { createPost, getPostData, postPostTable, postUpdatePostTable, getPostList } from "../../api/postAPI";

interface Props {
  rootCategoryId: number;
}

const CaseConference = ({ rootCategoryId }: Props) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [soaModalMode, setSoaModalMode] = useState<"add" | "edit" | null>(null);
  const [targetPost, setTargetPost] = useState<any>({});
  const [selectedPostId, setSelectedPostId] = useState<number | null>(null);
  const [attachmentModalVisible, setAttachmentModalVisible] = useState(false);
  const [meeting, setMeeting] = useState<any>([]);
  const [currentPost, setCurrentPost] = useRecoilState(currentPostAtom);
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const openSoaModal = () => {
    setModalVisible(true);
  };

  const handleOpenAttachmentModal = (postId: number) => {
    setSelectedPostId(postId);
    setAttachmentModalVisible(true);
  };

  const onRowClick = async (record: any) => {
    setCurrentPost(await getPostData(record?.id));
    navigate(`/post/${record?.id}?soa=true`, { state: { soaData: record } });
  };

  const closeSoaModal = () => {
    setModalVisible(false);
  };

  const handleCloseAttachmentModal = () => {
    setAttachmentModalVisible(false);
    setSelectedPostId(null);
  };

  const onFinish = async (values: any) => {
    try {
      const {
        meetAge,
        meetDiagnosis,
        meetGender,
        meetKppNumber,
        meetOrgan,
        meetOrganization,
      } = values;

      if (rootCategoryId) {
        if (soaModalMode === null) return;

        let requestParams;

        if (soaModalMode === "add") {
          requestParams = {
            categoryId: rootCategoryId,
            meetAge,
              meetDiagnosis,
              meetGender,
              meetKppNumber,
              meetOrgan,
              meetOrganization,
          };
          await postPostTable(requestParams);
          
        } else if (soaModalMode === "edit") {
          requestParams = {
            postId: targetPost?.id,
            age: meetAge,
              diagnosis: meetDiagnosis,
              gender: meetGender,
              kppNumber: meetKppNumber,
              organ: meetOrgan,
              organization: meetOrganization,
          };
          await postUpdatePostTable(requestParams);
        }
      }

      soaForm.setFieldsValue(initialValues); // 폼 동작 완료 후 폼 초기화
      refetchData();
      closeSoaModal();
    } catch (error) {
      console.error(error);
    }
  };

  const onFinishFailed: FormProps<any>["onFinishFailed"] = (errorInfo) => {
    console.error({ errorInfo });
  };

  const refetchData = async () => {
    try {
      const data = await getPostList(1, 9999, rootCategoryId, "id", "DESC");
      const flattenedData = data.map((post: any) => {
        if (post.postConference) {
          return {
            ...post, 
            ...post.postConference, 
          };
        }
        return post;
      });
      setMeeting(flattenedData);

    } catch (error) {
      console.error("Failed to fetch posts:", error);
    }
  };

  const [soaForm] = Form.useForm();
  const [initialValues] = useState<any>({
    meetAge: "",
    meetDiagnosis: "",
    meetGender: "",
    meetKppNumber: "",
    meetOrgan: "",
    meetOrganization: "",
  });

  const soaColumn: TableProps<any>["columns"] = [
    {
      title: "kpp number",
      dataIndex: "meetKppNumber",
      key: "meetKppNumber",
      align: "center",
      width: 110,
      render: (data: any, index: number) => {
        return (
          <>
            <span>{data ? data : "-"}</span>
          </>
        );
      },
    },
    {
      title: "gender",
      dataIndex: "meetGender",
      key: "meetGender",
      align: "center",
      width: 110,
      render: (data: any, index: number) => {
        return (
          <>
            <span>{data ? data : "-"}</span>
          </>
        );
      },
    },
    {
      title: "age",
      dataIndex: "meetAge",
      key: "meetAge",
      align: "center",
      width: 110,
      render: (data: any, index: number) => {
        return (
          <>
            <span>{data ? data : "-"}</span>
          </>
        );
      },
    },
    {
      title: "organ",
      dataIndex: "meetOrgan",
      key: "meetOrgan",
      align: "center",
      width: 110,
      render: (data: any, index: number) => {
        return (
          <>
            <span>{data ? data : "-"}</span>
          </>
        );
      },
    },
    {
      title: "diagnosis",
      dataIndex: "meetDiagnosis",
      key: "meetDiagnosis",
      align: "center",
      width: 110,
      render: (data: any, index: number) => {
        return (
          <>
            <Tooltip title={data}>
              <OverflowText
                style={{
                  display: "inline-block",
                  width: "110px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {data ? data : "-"}
              </OverflowText>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "organization",
      dataIndex: "meetOrganization",
      key: "meetOrganization",
      align: "center",
      width: 110,
      render: (data: any, index: number) => {
        return (
          <>
            <span>{data ? data : "-"}</span>
          </>
        );
      },
    },
    {
      title: "hasSlide",
      dataIndex: "hasSlide",
      key: "hasSlide",
      align: "center",
      width: 110,
      render: (data: any, index: number) => {
        return (
          <>
            <span>{data}</span>
          </>
        );
      },
    },
    {
      title: "attachment",
      dataIndex: "meetAttachment",
      key: "meetAttachment",
      align: "center",
      width: 110,
      render: (data: any, record: any) => {
        return (
          <CustomA
            onClick={(event) => {
              event.stopPropagation();
              handleOpenAttachmentModal(record.id)
            }}
          >
            Show
          </CustomA>
        );
      },
    },
    {
      title: "Action",
      key: "operation",
      width: 100,
      align: "center",
      fixed: "right",
      render: (record, data) => (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <CustomA
            onClick={async (event) => {
                event.stopPropagation();
                const postData = await getPostData(data.id);
                setCurrentPost(postData);
                navigate("/write", {
                  state: {
                    conferenceMode: true,
                    conferenceEditMode: true,
                    rootCategoryId,
                    postData,
                    conferenceInitialValues: {
                      meetKppNumber: data.meetKppNumber,
                      meetGender: data.meetGender,
                      meetAge: data.meetAge,
                      meetOrgan: data.meetOrgan,
                      meetDiagnosis: data.meetDiagnosis,
                      meetOrganization: data.meetOrganization,
                    },
                  },
                });
            }}
        >
            Edit
        </CustomA>
      ),
    },
  ];

  useEffect(() => {
      refetchData();
  }, []);

  useEffect(() => {
    if (soaModalMode === null) return;

    if (soaModalMode === "add") {
      soaForm.setFieldsValue(initialValues); // add 모드이면 폼 초기화
    } else if (soaModalMode === "edit" && targetPost) {
      const {
        meetAge,
        meetDiagnosis,
        meetGender,
        meetKppNumber,
        meetOrgan,
        meetOrganization,
      } = targetPost;
      soaForm.setFieldsValue({
        meetAge,
        meetDiagnosis,
        meetGender,
        meetKppNumber,
        meetOrgan,
        meetOrganization,
      });
    }
  }, [soaModalMode, targetPost]);

  return (
    <div className="soa-table-wrapper">
      <div
        className="btn-wrapper"
        style={{
        display: "flex",
        justifyContent: "flex-start",
        marginBottom: "0.5rem",
        width: "100%",
        }}
      >
        <Button
          onClick={() => {
            navigate("/write", { state: { conferenceMode: true, rootCategoryId } });
          }}
          >
          Add
        </Button>
      </div>
      <SoaTable
        rowKey="id"
        id="soa-table"
        columns={soaColumn}
        dataSource={meeting}
        pagination={{
          position: ["bottomCenter"],
          current: Number(searchParams.get("page")) || 1,
          onChange: (page) => {
            setSearchParams(prev => {
              const newParams = new URLSearchParams(prev);
              newParams.set("page", page.toString());
              return newParams;
            });
          }
        }}
        scroll={{ x: "max-content" }}
        onRow={(record) => ({
        onClick: () => {
          onRowClick(record);
        }
        })}
      />
      <Modal
        centered
        title={soaModalMode === "edit" ? "Edit" : "Add"}
        open={modalVisible}
        onCancel={closeSoaModal}
        footer={null}
      >
        <Form
          name={`soa-add-form`}
          form={soaForm}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item name={`meetKppNumber`} label="kpp number">
            <Input />
          </Form.Item>
          <Form.Item name={`meetGender`} label="gender">
            <Input />
          </Form.Item>
          <Form.Item name={`meetAge`} label="age">
            <Input />
          </Form.Item>
          <Form.Item name={`meetOrgan`} label="organ">
            <Input />
          </Form.Item>
          <Form.Item name={`meetDiagnosis`} label="diagnosis">
            <Input />
          </Form.Item>
          <Form.Item name={`meetOrganization`} label="organization">
            <Input />
          </Form.Item>
          <Form.Item style={{ textAlign: "end", marginTop: "1rem" }}>
            <Button onClick={closeSoaModal}>취소</Button>
            <Button
              style={{ marginLeft: "0.5rem" }}
              type="primary"
              htmlType="submit"
              >
              {soaModalMode === "edit" ? "수정" : "등록"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        // title="Attachments"
        open={attachmentModalVisible}
        onCancel={handleCloseAttachmentModal}
        footer={null}
        width="40%"
      >
        {selectedPostId && <Attatchment postId={selectedPostId} />}
      </Modal>
    </div>
  )
};

const SoaTable = styled(Table)`
  #soa-table {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    border: 1px solid #d9d9d9;

    .ant-table-thead tr > th {
      background-color: rgba(237, 237, 237, 0.94);

      &::before {
        border: 1px solid #d9d9d9;
      }
    }
    .ant-table-row {
      cursor: pointer;
      &:hover {
        // text-decoration: underline;
        color: darkcyan;
      }
    }
  }
`;

const OverflowText = styled.span`
  display: inline-block;
  width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;


const CustomA = styled.a(() => ({
  color: "#1677ff",
  "&:hover": {
    color: "#1699ff",
  },
}));


export default CaseConference;